/* eslint-disable no-unused-vars */
export const getAutpApplySettingsStyle = (_, { palette = {} }) => ({
  recommendationAutoApplySettings: {
    '& .recommendation-navigate-back-ground': {
      height: 44,
      display: 'flex',
      background: '#F3F2F1',
      borderBottom: 'solid 1px #e1dfdd',
      '& .recommendation-navigate-back': {
        marginLeft: 10,
        '& .iconba-Back': {
          color: '#0078D4',
        },
        '& .recommendation-navigate-back-text': {
          color: '#0078D4',
          marginLeft: 8,
        },
      },
    },
    '& .auto-apply-settings-container': {
      marginTop: 24,
      marginLeft: 32,
      marginRight: 32,
      '& .auto-apply-settings-pitching': {
        marginTop: 24,
        borderBottom: `1px solid ${palette.neutralSecondary}`,
        paddingBottom: 24,
        '& .pitching-text': {
          lineHeight: '24px',
        },
        '& .HelpTopic': {
          textDecoration: 'unset',
        },
        '& .history-page-link, & .spliter': {
          color: '#0078d4',
        },
      },
      '& .auto-apply-settings-title': {
        fontSize: 20,
        fontWeight: 'bold',
      },
      '& .auto-apply-settings-group': {
        marginTop: 10,
        '& .category-group-container': {
          marginBottom: 36,
          '& .category-title': {
            marginBottom: 16,
            fontSize: 18,
            fontWeight: 'bold',
          },
          '& .category-group': {
            display: 'grid',
            gridTemplateColumns: '600px 600px',

            '& .ms-TooltipHost': {
              width: 'fit-content',
            },
          },
        },
      },
      '& .auto-apply-settings-action-buttons .btn-primary': {
        marginRight: 8,
      },
      '& .ad-settings-link': {
        marginTop: 24,
        marginBottom: 26,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 8,
        background: palette.themeLighterAlt,
        '& a': {
          textDecoration: 'unset',
        },
        '& span, & a': {
          fontSize: 12,
        },
        '& .iconba': {
          marginRight: 8,
        },
      },
    },
  },
});
